export default __webpack_public_path__ + "static/media/playButton.e3539f42.svg";